export default __webpack_public_path__ + "static/media/t8.ddb08986.jpg";